import axios from "axios";
import Qs from "qs";
import { createStore } from "redux";
import { url, ocpcUrl, localUrl, sysUrl } from "./config";
import MobileDetect from "mobile-detect";
import _ from "lodash";
import { storageLocal } from "./view/util/storage";

const mobileDetect = new MobileDetect(navigator.userAgent);

export const imgPlaceholder = {
  default:
    "data:image/png;base64,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",
};

const reducer = (state = {}, action) => {
  if (action.data) {
    return action.data;
  }
  return state;
};

export const redux = createStore(reducer);

const createAxios = axios.create({ baseURL: url });

createAxios.interceptors.request.use(
  (config) => {
    config.paramsSerializer = (params) =>
      Qs.stringify(params, { arrayFormat: "indices" });

    let url = "";
    url =
      config.url.indexOf("?") === -1 ? config.url : config.url.split("?")[0];
    // console.log(url);

    if (url && url === "/home/trade/pay") {
      config.baseURL = sysUrl;
    } else {
      let tgmList = [
        "/ocpc/NoticeDepart",
        "/ocpc/getVid",
        "/ocpc/reportVid",
        "/ocpc/handleVid",
        "/tgm/open_game_detail",
      ];

      if (url && tgmList.indexOf(url) > -1) {
        config.baseURL = ocpcUrl;
      }

      if (
        url &&
        (url === "/get/sts" ||
          url === "/handle/subpackage" ||
          url === "/show/subpackage")
      ) {
        config.baseURL = localUrl;
      }

      let listv4 = [
        "/v4/ReportRecords",
        "/v4/channel_rule",
        "/v4/search/suggestion",
        "/v4/search/recommend",
        "/v4/search/list",
        "/v4/tracking/generate/kid",
        "/v4/tracking/report/search",
        "/v4/tracking/common/kid/mapping",
      ];
      if (url && listv4.indexOf(url) > -1) {
        config.headers["appid"] = "991701";
      }

      if (storageLocal.has("tgm_uuid")) {
        config.headers["vid"] = storageLocal.get("tgm_uuid");
      }

      if (
        localStorage.getItem("deviceToken") &&
        url !== "/get/sts" &&
        url !== "/handle/subpackage" &&
        url !== "/show/subpackage" &&
        url !== "/v4/ReportRecords" &&
        url !== "/v4/channel_rule" &&
        url !== "/v4/tracking/report/search"
      ) {
        config.headers["deviceToken"] = localStorage.getItem("deviceToken");
      }

      if (
        storageLocal.has("boxFirstKid")
        // &&
        // url === "/v4/tracking/report/search"
      ) {
        config.headers["root-kid"] = storageLocal.get("boxFirstKid");
      }

      if (url == "/v3/base/game/getGameDetail") {
        config.headers["is-internal"] = 1;
      }

      config.headers["device-type"] =
        mobileDetect.is("iPhone") ||
        mobileDetect.is("iPad") ||
        navigator.userAgent == "app"
          ? "10"
          : "20";

      config.headers["X-Requested-With"] = "XMLHttpRequest";

      config.headers["brand"] =
        (localStorage.getItem("app") &&
          JSON.parse(localStorage.getItem("app"))?.brand) ||
        "9917";

      config.headers["channel"] = localStorage.getItem("agent") || "x7z1";

      let token = localStorage.getItem("token");
      if (token) {
        config.headers["Token"] = token;
      }

      if (localStorage.getItem("udid")) {
        config.headers["udid"] = localStorage.getItem("udid");
      }

      if (localStorage.getItem("key")) {
        config.headers["key"] = localStorage.getItem("key");
      }

      let user_id = localStorage.getItem("user_id");
      let username = localStorage.getItem("username");
      if (
        (user_id || username) &&
        url !== "/get/sts" &&
        url !== "/handle/subpackage" &&
        url !== "/show/subpackage" &&
        listv4.indexOf(url) === -1 &&
        tgmList.indexOf(url) === -1
      ) {
        config.headers["member-id"] = user_id;
        config.headers["username"] = username;

        if (config.data instanceof FormData) {
          if (!config.data.get("member_id")) {
            config.data.append("member_id", user_id);
          }
          if (!config.data.get("username")) {
            config.data.append("username", username);
          }
        } else {
          config.data = { username, member_id: user_id, ...config.data };
        }
      }

      if (
        config.url == "/v3/base/apphome/getAppHome" ||
        config.url == "/v3/base/search/index" ||
        config.url == "/v3/base/game/searchAdd" ||
        config.url == "/v3/base/game/getGameDetail" ||
        config.url == "/v3/base/appcategorize/getAppCategorizeData"
      ) {
        config.headers["device"] = "web";
      }
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

createAxios.interceptors.response.use(
  (res) => {
    console.log("请求响应----", res);
    // let keys = [];
    // if (res.config?.url?.indexOf('getMyGiftList') > -1) {
    //   keys.push('gift_name');
    // }
    // nameResolveRecursion(res.data, keys);
    if (res?.data?.status?.error_code == 1016) {
      localStorage.removeItem("user_id");
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("token");
      let url = window.location.hash.substring(1);
      if (url.indexOf("/login") === -1 && url.indexOf("/phonelogin") === -1) {
        general.callback = url;

        // 触发自定义事件，让组件处理登录弹窗
        window.dispatchEvent(new CustomEvent("showLogin", { detail: true }));
        document.body.style.overflow = "hidden";
        // general.history.push(
        //   URI("/login").addQuery("callback", general.callback).toString()
        // );
      }
      return Promise.reject(new Error("需要登录"));
    }
    return res;
  },
  (err) => {
    setTimeout(() => {
      try {
        axios.post(`${url}/v3/log`, {
          log: err,
          userAgent: navigator.userAgent,
        });
      } catch (e) {}
    }, 222);
  },
);

const general = {
  history: null,
  historys: [],
  location: null,
  game: {},
  goBack(callback) {
    if (
      !(
        window.navigator.standalone ||
        window.location.hostname === "localhost" ||
        window.location.hostname.startsWith("192.168")
      )
    ) {
      general.history.push("/");
      return;
    }
    // console.warn({ callback1: callback, callback2: general.callback });
    if (callback) {
      if (general.callback) {
        let hit;
        // console.log({ callback: general.callback, url });
        general.callbacking = true;
        var si = setInterval(() => {
          let url = window.location.hash.substring(1);
          if (url === general.callback || url === "/") {
            hit = true;
            clearInterval(si);
            general.callbacking = null;
            general.callback = null;
            redux.dispatch({
              type: "type",
              data: { url },
            });
          } else {
            window.history.back();
          }
        }, 10);
        if (!hit) {
          general.history.push(general.callback);
        }
        return;
      }
    }
    general.history.push("/");
  },
  axios: createAxios,
  isLogin() {
    return !!localStorage.getItem("token");
  },
  agent: localStorage.getItem("agent") || "x7z1",
  setAgent() {
    localStorage.setItem("agent", this.agent);
  },
  // || "00008030-000C39E83445402E" || "00008101-00080D42266B001E"
  udid: localStorage.getItem("udid") || "",
  setUdid() {
    localStorage.setItem("udid", this.udid);
  },
  key: localStorage.getItem("key"),
  setKey() {
    localStorage.setItem("key", this.key);
  },
  app: (localStorage.getItem("app") &&
    JSON.parse(localStorage.getItem("app"))) || {
    appname: "9917游戏",
    appicon: "/resources/icon.png",
    applogo: "/resources/account/logo.png",
  },
  setApp() {
    localStorage.setItem("app", JSON.stringify(this.app));
  },
  config: {},
  user: {},
  guide: "",
  guided: localStorage.getItem("guided") || "",
  setGuided() {
    localStorage.setItem("guided", this.guided);
  },
  cloud:
    window.location.hash.substring(1).startsWith("/game/cloud") &&
    navigator.standalone &&
    !document.referrer,
};

export const spm = (spm) => general.axios.post("/v3/spm", { spm });

export const nameResolve = (name) => {
  return name?.split("-") || [];
};

export const nameResolveRecursion = (data, keys = []) => {
  if (_.isObject(data)) {
    for (const key in data) {
      if (_.isObject(data[key]) || _.isArray(data[key])) {
        nameResolveRecursion(data[key], keys);
      } else if (["game_name", ...keys].includes(key)) {
        let res = nameResolve(data[key]);
        data[key + "_main"] = res[0];
        data[key + "_branch"] = res[1];
      }
    }
  } else if (_.isArray(data)) {
    for (const val of data) {
      if (_.isObject(val) || _.isArray(val)) {
        nameResolveRecursion(val, keys);
      }
    }
  }
};

export default general;
